import { ICoursesReducer } from '../Interfacese/ICoursesReducer';
import { coursesInitState } from './CoursesInitState';
import { IAction } from '../../../__core/Interfaces/IAction';
import { IEvent } from '../../../__core/Interfaces/IEvent';
import { coursesListReducer } from './CoursesList';
import { CoursesListResponse } from '../Types/CoursesListResponse';
import { productsListReducer } from './ProductsList';
import { ProductsListResponse } from '../Types/ProductsListResponse';

type CoursesReducerAction =
  | IAction<CoursesListResponse>
  | IAction<ProductsListResponse>
  | IEvent;

export const coursesReducer = (
  state: ICoursesReducer = coursesInitState,
  action: CoursesReducerAction
): ICoursesReducer => ({
  coursesList: coursesListReducer(
    state.coursesList,
    action as IAction<CoursesListResponse>
  ),
  productList: productsListReducer(
    state.productList,
    action as IAction<ProductsListResponse>
  ),
});
